import React, { useState } from "react";
import "../styles/Team.css";
import { Helmet } from "react-helmet";
import Kartikey from "../../assets/images/Team2026-27/Kartikey-Mittal.jpg";
import Utkarsh from "../../assets/images/Team2026-27/UtkarshBansal (1).jpeg";
import sec1 from "../../assets/images/Team2026-27/Jahanvi .jpg";
import sec2 from "../../assets/images/Team2026-27/Sugam_sarc.png";
import sec3 from "../../assets/images/Team2026-27/Satyam .jpg";
import sec4 from "../../assets/images/Team2026-27/kartikey (1).jpg";
import sec5 from "../../assets/images/Team2026-27/sarc_prakhar.jpg";
import sec6 from "../../assets/images/Team2026-27/Nirmit.jpeg";
import sec7 from "../../assets/images/Team2026-27/Geetansh.jpg";
import sec8 from "../../assets/images/Team2026-27/Anshul_sarc.jpeg";
import sec9 from "../../assets/images/Team2026-27/Daksh.jpg";
import sec10 from "../../assets/images/Team2026-27/Akshita sarc .jpg";
import sec11 from "../../assets/images/Team2026-27/Ansh Jha SARC.jpg";
import sec12 from "../../assets/images/Team2026-27/Aaryan.png";
import sec14 from "../../assets/images/Team2026-27/Rishita Rakshit.jpeg";

import "@fortawesome/fontawesome-free/css/all.min.css";

export const Team = () => {
  return (
    <body>
      <div className="center">
        <div className="team">
          <div className="text">MEET OUR TEAM</div>
        </div>
      </div>

      <div className="ctm-section">
        <div className="ctm-header">
          <h2 className="ctm-title">Core Team Members</h2>
          <div className="ctm-underline"></div>
        </div>

        <div className="split-screen">
          <div className="team-member-card">
            <div className="card-inner">
              <div className="ctm-image-wrapper">
                <div className="ctm">
                  <img src={Kartikey} alt="Kartikey Mittal" />
                </div>
                <div className="card-glow"></div>
              </div>
              <div className="member-info">
                <h3 className="member-name">Kartikey Mittal</h3>
                <p className="member-role">Core Team Member</p>
                <div className="contact-info">
                  <i className="fas fa-phone-alt"></i>
                  <span>+91 88540 49125</span>
                </div>
              </div>
            </div>
          </div>

          <div className="team-member-card">
            <div className="card-inner">
              <div className="ctm-image-wrapper">
                <div className="ctm">
                  <img src={Utkarsh} alt="Utkarsh Bansal" />
                </div>
                <div className="card-glow"></div>
              </div>
              <div className="member-info">
                <h3 className="member-name">Utkarsh Bansal</h3>
                <p className="member-role">Core Team Member</p>
                <div className="contact-info">
                  <i className="fas fa-phone-alt"></i>
                  <span>+91 95716 18135</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="coordis">
        <div className="secretary-header">
          <h2 className="secretary-title">Alumni Secretaries</h2>
          <div className="secretary-underline"></div>
          <p className="secretary-subtitle">
            The backbone of our alumni network
          </p>
        </div>
        <div className="row">
          <div className="profile profile1">
            <img src={sec1} alt="Jahanvi" />
            <div className="title">Jahanvi</div>
          </div>

          <div className="profile profile1">
            <img src={sec2} alt="Sugam Kumar Thakur" />
            <div className="title">Sugam Kumar Thakur</div>
          </div>
          <div className="profile profile1">
            <img src={sec3} alt="Satyam Yeola" />
            <div className="title">Satyam Yeola</div>
          </div>
          <div className="profile profile1">
            <img src={sec4} alt="Kartikay Raina" />
            <div className="title">Kartikay Raina</div>
          </div>

          <div className="profile profile1">
            <img src={sec5} alt="Prakhar Maheshwari" />
            <div className="title">Prakhar Maheshwari</div>
          </div>
          <div className="profile profile1">
            <img src={sec6} alt="Nirmit Bangar" />
            <div className="title">Nirmit Bangar</div>
          </div>
          <div className="profile profile1">
            <img src={sec7} alt="Geetansh Goyal" />
            <div className="title">Geetansh Goyal</div>
          </div>
        </div>

        <div className="row">
          <div className="profile profile1">
            <img src={sec8} alt="Anshul Sevaiye" />
            <div className="title">Anshul Sevaiye</div>
          </div>

          <div className="profile profile1">
            <img src={sec9} alt="Daksh Meena" />
            <div className="title">Daksh Meena</div>
          </div>

          <div className="profile profile1">
            <img src={sec10} alt="Akshita Baid" />
            <div className="title">Akshita Baid</div>
          </div>

          <div className="profile profile1">
            <img src={sec11} alt="Ansh Jha" />
            <div className="title">Ansh Jha</div>
          </div>

          <div className="profile profile1">
            <img src={sec12} alt="Aaryan Agrawal" />
            <div className="title">Aaryan Agrawal</div>
          </div>

          <div className="profile profile1">
            {/* Gitika Sharma's photo was not supplied in Team2026-27. */}
            <div className="title">Gitika Sharma</div>
          </div>

          <div className="profile profile1">
            <img src={sec14} alt="Rishita Rakshit" />
            <div className="title">Rishita Rakshit</div>
          </div>
        </div>

        <div className="row"></div>
      </div>

      <footer className="footer">
        <div className="footer-content">
          <p>Connect with us on</p>
          <div className="social-icons">
            <a href="https://www.facebook.com/SARC.IITB/" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="https://www.linkedin.com/company/student-alumni-relations-cell/" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-linkedin"></i>
            </a>
            <a href="https://www.instagram.com/sarc_iitb/?hl=en" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
          <p>Made with ❤️ by SARC</p>
        </div>
      </footer>
    </body>
  );
};
